import React, { Fragment } from "react";
import { Box, Stack, Typography, Button } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom"; // React Router yönlendirme
import Slider from "../../../shared/components/myslider";

const apiUrl = process.env.REACT_APP_API_URL;

function HeadSection() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Ekran boyutunu kontrol eder
  const navigate = useNavigate(); // Navigasyon için hook

  return (
    <Fragment>
      {isMobile ? (
        // Mobil görünüm için Slider
        <Box width="100%" sx={{ justifyContent: "center", mt: "5vh" }}>
           <Box
                  sx={{
                    position: "relative",
                     height: "35vh",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  {/* Arka Plan Resmi */}
                  <video
                    loading='lazy'
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  >
                    <source src={apiUrl + "/static/media/2.mp4"} type="video/mp4" />
                    Tarayıcınız video öğesini desteklemiyor.
                  </video>

                  {/* Üstteki Metin ve Buton */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "30%",
                      left: "10%",
                      width: "80%",
                      height: "auto",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      textAlign: "center",
                      borderRadius: 10,
                    }}
                  >
                    {/* Metin */}
                    <Typography variant='body1' sx={{ m: 2 }}>
                    Jokaisella osalla on oma tarinansa. Oletko valmis löytämään omasi ?
                    </Typography>

                    {/* Buton (Yönlendirme Eklenmiş) 
                    <Button
                      onClick={() => {localStorage.setItem('filter','Sohvat')
                        navigate("/products")}} // 👈 Burada yönlendirme yapılıyor
                      variant="contained"
                      sx={{
                        mb: 2,
                        backgroundColor: "white",
                        color: "black",
                        "&:hover": {
                          backgroundColor: "gray",
                          color: "white",
                        },
                      }}
                    >
                      Kaytetty Tuotteet
                    </Button>*/}
                  </Box>
                </Box>
        </Box>
      ) : (
        // Büyük ekranlar için Grid düzeni
        <Box sx={{ width: "100%", display: "flex", mt: "12vh", justifyContent: "center" }}>
          <Box sx={{ width: { xs: "100%", lg: "90%", display: "flex", justifyContent: "center", border: 2 } }} mt="5vh">
            <Stack direction="row" spacing={2}>
              <Stack width="60%">
                <Box
                  sx={{
                    position: "relative",
                    height: "62vh",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  {/* Arka Plan Resmi */}
                  <video
                   loading='lazy'
                    autoPlay
                    muted
                    loop
                    playsInline
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  >
                    <source src={apiUrl + "/static/media/2.mp4"} type="video/mp4" />
                    Tarayıcınız video öğesini desteklemiyor.
                  </video>

                  {/* Üstteki Metin ve Buton */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "35%",
                      left: "20%",
                      width: "60%",
                      height: "auto",
                       //backgroundColor: "rgba(8, 8, 8, 0.3)", Arka planı koyulaştırır
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      textAlign: "center",
                      borderRadius: 10,
                    }}
                  >
                    {/* Metin */}
                    <Typography variant= 'h4' sx={{ m: 2 }}>
                    Jokaisella osalla on oma tarinansa. Oletko valmis löytämään omasi ?
                    </Typography>

                    {/* Buton (Yönlendirme Eklenmiş) */}
                    <Button
                      onClick={() => {localStorage.setItem('filter','Sohvat')
                        navigate("/products")}} // 👈 Burada yönlendirme yapılıyor
                      variant="contained"
                      sx={{
                        mb: 2,
                        backgroundColor: "white",
                        color: "black",
                        "&:hover": {
                          backgroundColor: "gray",
                          color: "white",
                        },
                      }}
                    >
                      Kaytetty Tuotteet
                    </Button>
                  </Box>
                </Box>
              </Stack>
              <Stack width="40%" direction="column" spacing={2}>
              <Box
                  sx={{
                    position: "relative",
                    height: "30vh",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  {/* Arka Plan Resmi */}
                  <img
                  loading="lazy"
                    src={`${apiUrl}/static/media/1d.jpg`}
                    alt="Käytetty Sohva"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />

                  {/* Üstteki Metin ve Buton */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "35%",
                      left: "20%",
                      width: "60%",
                      height: "auto",
                      backgroundColor: "rgba(0, 0, 0, 0.3)", // Arka planı koyulaştırır
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      textAlign: "center",
                      borderRadius: 10,
                    }}
                  >
                    {/* Metin */}
                    <Typography variant="h4" sx={{ mb: 2 }} >
                      Nopea ja Laadukas palvelu
                    </Typography>

                    {/* Buton (Yönlendirme Eklenmiş) */}
                  </Box>
                </Box>
                <Box
                  sx={{
                    position: "relative",
                    height: "30vh",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  {/* Arka Plan Resmi */}
                  <img
                  loading="lazy"
                    src={`${apiUrl}/static/media/4d.png`}
                    alt="Käytetty Sänky"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />

                  {/* Üstteki Metin ve Buton */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "30%",
                      left: "20%",
                      width: "60%",
                      height: "auto",
                      backgroundColor: "rgba(0, 0, 0, 0.3)", // Arka planı koyulaştırır
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      textAlign: "center",
                      borderRadius: 10,
                    }}
                  >
                    {/* Metin */}
                    <Typography variant="h4" sx={{ mb: 2 }}>
                      Uudet Huonekalut
                    </Typography>

                    {/* Buton (Yönlendirme Eklenmiş) */}
                    <Button
                      onClick={() => {localStorage.setItem('filter','Uudet Huonekalut')
                        navigate("/products")}} // 👈 Burada yönlendirme yapılıyor
                      variant="contained"
                      sx={{
                        mb: 2,
                        backgroundColor: "white",
                        color: "black",
                        "&:hover": {
                          backgroundColor: "gray",
                          color: "white",
                        },
                      }}
                    >
                      Osta Nyt
                    </Button>
                  </Box>
                </Box>
              </Stack>
            </Stack>
          </Box>
        </Box>
      )}
    </Fragment>
  );
}

export default HeadSection;
